<petitioner-details-library [primaryData]="primaryData" (onDialogClose)="handleDialogClose()"
  [isForeignCompany]="isForeignCompany" style="width:100%"></petitioner-details-library>